module.exports = __webpack_public_path__ + "img/logement-espace-exterieur-intermediaire.93c141c9.png";